// extracted by mini-css-extract-plugin
export default {"box":"Giveaway_box__tzqKb","btn":"Giveaway_btn__BY2+l","unactive":"Giveaway_unactive__E-UPI","add":"Giveaway_add__vDxZu","delete":"Giveaway_delete__pwd8n"};